/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_OccupationInputs */

const en_us2_profile_row_occupation = /** @type {(inputs: Profile_Row_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work`)
};

const pt_br2_profile_row_occupation = /** @type {(inputs: Profile_Row_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho`)
};

const es_419_profile_row_occupation = /** @type {(inputs: Profile_Row_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajo`)
};

const pt_pt2_profile_row_occupation = /** @type {(inputs: Profile_Row_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho`)
};

const fr_fr2_profile_row_occupation = /** @type {(inputs: Profile_Row_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travail`)
};

const de_de2_profile_row_occupation = /** @type {(inputs: Profile_Row_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeit`)
};

const it_it2_profile_row_occupation = /** @type {(inputs: Profile_Row_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro`)
};

/**
* | output |
* | --- |
* | "Work" |
*
* @param {Profile_Row_OccupationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_occupation = /** @type {((inputs?: Profile_Row_OccupationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_OccupationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_occupation(inputs)
	if (locale === "es-419") return es_419_profile_row_occupation(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_occupation(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_occupation(inputs)
	if (locale === "de-DE") return de_de2_profile_row_occupation(inputs)
	if (locale === "it-IT") return it_it2_profile_row_occupation(inputs)
	return en_us2_profile_row_occupation(inputs)
});
export { profile_row_occupation as "profile.row_occupation" }